
import { defineComponent } from 'vue';

import figmaVariables from '@/../figma.json';

export default defineComponent({
  name: 'CssVariables',
  data: () => ({
    useFigma: true,
  }),
  computed: {
    variables(): string {
      if (!this.useFigma) {
        return '';
      }

      let result = '';

      Object.keys(figmaVariables).forEach((key: string) => {
        result += `--${key.slice(0, -1)}: ${
          (figmaVariables as Record<string, string>)[key]
        };\n`;
      });

      return result;
    },
  },
});
